module.exports = __webpack_public_path__ + "img/nobleriding_option_04.048bf597.jpg";